if (typeof Alfa2017 == 'undefined') var Alfa2017 = {};
var _local_resize_timer = false;

Alfa2017.Util = {
	setup: function() {
		


		//window.console.log ("util");
		jQuery(window).scroll(function(){ 	Alfa2017.Util.onscroll();	});
		jQuery(window).resize(function(){	Alfa2017.Util.onresize();	});
		jQuery(window).resize(function(){	Alfa2017.Util.onresizetimer();	});
		this.resetscroll();
		//this.addResponsiveMenuClose();
		//this.initScrollHash("false");


	},
	isThisNotDesktop : function(){

			var agent = navigator.userAgent;
            if(agent.search(/iPhone/) != -1 || agent.search(/iPad/) != -1 || agent.search(/iPod/) != -1 || agent.search(/Android/) != -1){
                return true;
            } else {
            	return false;
            }

	},





	//
	// LISTNER GROUP
	//
	scrollgroup: [],
	onscroll: function() {
        for(var i=0; i< Alfa2017.Util.scrollgroup.length; i++ ){ Alfa2017.Util.scrollgroup[i]();}
    },
	resizegroup: [],
    onresize: function() {
        for(var i=0; i< Alfa2017.Util.resizegroup.length; i++ ){ Alfa2017.Util.resizegroup[i]();}
    },
	resizetimergroup: [],
	onresizetimer : function(){

		if (_local_resize_timer !== false) {
	        clearTimeout(_local_resize_timer);
	    }
	    _local_resize_timer = setTimeout(function() {
	        //window.console.log('resized');
	        for(var i=0; i< Alfa2017.Util.resizetimergroup.length; i++ ){
				Alfa2017.Util.resizetimergroup[i]();
			}
	    }, 500);
	},


	//
	// UTILITY
	//
	resetscroll : function(){
		// reset animation when scroll
		jQuery('body,html').bind('scroll mousedown wheel DOMMouseScroll mousewheel keyup', function(e){
			if ( e.which > 0 || e.type == "mousedown" || e.type == "mousewheel"){
				jQuery("html,body").stop();
			}
		});
	}
};




Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};